import React, {Component, Fragment} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {
  DragSource,
  DropTarget
} from 'react-dnd'

import Icon from 'components/Icon'

const itemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    }
  }
}

const itemTarget = {
  hover(props, monitor, component) {
    if (!component) {
      return null
    }
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    if (dragIndex === hoverIndex) {
      return
    }

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
    const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2
    const clientOffset = monitor.getClientOffset()
    const hoverClientX = clientOffset.x - hoverBoundingRect.left

    if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
      return
    }

    if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
      return
    }

    props.moveItem(dragIndex, hoverIndex)

    monitor.getItem().index = hoverIndex
  }
}

class MultiselectItem extends Component {
  static propTypes = {
    hovered: PropTypes.bool,
    isDragging: PropTypes.bool,
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    label: PropTypes.string,
    variants: PropTypes.array,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onDelete: PropTypes.func
  }

  render() {
    const {
      onMouseEnter,
      onMouseLeave,
      onDelete,
      hovered,
      isDragging,
      connectDragSource,
      connectDropTarget
    } = this.props

    const classNames = classnames('metrics-multiselect_item', {
      'is-hovered': hovered,
      'is-dragging': isDragging
    })

    return (
      connectDragSource &&
      connectDropTarget &&
      connectDragSource(
        connectDropTarget(
          <div
            className={classNames}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <div className='metrics-multiselect_handle'>
              <Icon name='hamburger' size='10px' />
            </div>
            {this.renderLabel()}
            <div className='metrics-multiselect_delete' onClick={onDelete}>
              <Icon name='new-cross' size='7px' />
            </div>
          </div>
        )
      )
    )
  }

  renderLabel() {
    const {label, variants} = this.props

    if (!variants) return label

    return (
      <Fragment>
        {label}
        {variants.map((variant, index) => (
          <span key={index} className='metrics-multiselect_item_variant'>{variant.label}</span>
        ))}
      </Fragment>
    )
  }
}

const WithDragSource = DragSource('item', itemSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
}))(MultiselectItem)

export default DropTarget('item', itemTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(WithDragSource)



// WEBPACK FOOTER //
// ./client/components/MetricsMultiselect/Item.js